import { DetailResponseData, ListResponseData, QueryParams } from "./base";

// country
export interface Country {
  id: string;
  name: string;
  alpha_two_code: boolean;
}

export interface CountryListResponseData extends ListResponseData<Country> {}

// country  state
export interface CountryState {
  id: string;
  name: string;
}

export interface CountryStateListResponseData extends ListResponseData<CountryState> {}

export interface CountryStateListQueryParams extends QueryParams {
  fCountryId?: string;
}

// journey type
export interface JourneyTypeSimple {
  id: string;
  name: string;
}

export interface JourneyType {
  id: string;
  name: string;
  created_at: string;
}

export interface JourneyTypeListResponseData extends ListResponseData<JourneyType> {}

// contact platform
export interface ContactPlatform {
  id: string;
  name: string;
  code:
    | "linkedin"
    | "messenger"
    | "personal-phone"
    | "website"
    | "whatsapp"
    | "work-email"
    | "work-phone";
}

export const CONTACT_PLATFORM_CODE = {
  LINKEDIN: "linkedin",
  MESSENGER: "messenger",
  PERSONAL_PHONE: "personal-phone",
  WEBSITE: "website",
  WHATSAPP: "whatsapp",
  WORK_EMAIL: "work-email",
  WORK_PHONE: "work-phone",
};

export interface ContactPlatformListResponseData extends ListResponseData<ContactPlatform> {}

// Campus activity
export interface CampusActivity {
  id: string;
  name: string;
  parent: CampusActivity | null;
}

export interface CampusActivityListResponseData extends ListResponseData<CampusActivity> {}

export interface CreateCampusActivityPayload {
  name: string;
  parent_id: string | null;
}

export interface CreateCampusActivityResponseData extends DetailResponseData<
  []
> {}

export interface UpdateCampusActivityPayload extends CreateCampusActivityPayload {}

export interface UpdateCampusActivityResponseData extends DetailResponseData<
  []
> {}

// Fields
export enum FieldType {
  Career = "career",
  Education = "education",
}

export interface Field {
  id: string;
  name: string;
  parent: Field | null;
  type: FieldType;
}

export interface FieldListResponseData extends ListResponseData<Field> {}

export interface CreateFieldPayload {
  name: string;
  parent_id: string | null;
  type: FieldType;
}

export interface CreateFieldResponseData extends DetailResponseData<[]> {}

export interface UpdateFieldPayload extends CreateFieldPayload {}

export interface UpdateFieldResponseData extends DetailResponseData<[]> {}
